import React, { useState } from 'react'

import { Helmet } from 'react-helmet-async';
import { useAuth0 } from '@auth0/auth0-react';

export const LoginPage = () => {
    const { loginWithRedirect } = useAuth0();

    return (
        <>
            <Helmet>
                <title>Login - Growing People</title>
            </Helmet>

            <div className="primarybutton w-inline-block" onClick={() => loginWithRedirect()}>
                <div>LOGIN</div>
            </div>
        </>
    )
}